import { useTeamsStore } from "@/store/teamsStore";
import { User as UserIcon } from "lucide-react";
import { formatUserName } from "@forgepoint/shared";

/**
 * Displays a user's name with a user icon for custom fields.
 * @param userId - The user ID to resolve
 * @param inline - Whether to render in the large inline style or compact standalone style
 */
export function UserFieldDisplay({
  userId,
  inline,
}: {
  userId: string;
  inline: boolean;
}) {
  const users = useTeamsStore((state) => state.users);
  const user = users.find((u) => u.id === userId);

  if (!user) {
    const emptyClass = inline
      ? "text-2xl font-bold text-muted-foreground/30"
      : "text-sm text-muted-foreground/50";
    return <p className={emptyClass}>&mdash;</p>;
  }

  const name = formatUserName(user.firstName, user.lastName, user.email);

  if (inline) {
    return (
      <div className="flex items-center gap-2">
        <UserIcon className="h-5 w-5 text-muted-foreground shrink-0" />
        <p className="text-2xl font-bold">{name}</p>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5">
      <UserIcon className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
      <p className="text-sm font-medium">{name}</p>
    </div>
  );
}
